import { Component, OnInit, NgZone } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { getLocalTranslate } from 'src/app/helpers/global-functions'
import { UserService } from 'src/app/services/user.service';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  public courseId: string;

  public showSpinner: boolean;

  isShow: boolean = false;

  loginForm: FormGroup;

  welcomeBack:string = 'Welcome Back'
  newUser:string = 'New to Camedu?'
  signUp:string = 'Sign up'
  emailText:string = 'Email'
  passwordText:string = 'Password'
  login:string = 'Login'
  forgotPassword:string = 'Forgot Password?'
  connectFacebook:string = 'Connect with Facebook'

  constructor(
    private authService: AuthService,
    private router: Router,
    private location: Location,
    private toastr: ToastrService,
    private userService:UserService,
    private zone:NgZone,
    private titleService: Title
  ) { }

  ngOnInit() {
    this.needTranslate()
    this.courseId = this.location.getState()["courseId"];
    this.loginForm = new FormGroup({
      email: new FormControl('', [
        Validators.required,
        Validators.email
      ]),
      password: new FormControl('', [
        Validators.required,
        Validators.minLength(6)
      ]),
    });
  }

  needTranslate(){
    this.welcomeBack = getLocalTranslate('welcome-back',this.welcomeBack)
    this.newUser = getLocalTranslate('new-to-camEdu',this.newUser)
    this.signUp = getLocalTranslate('sign-up',this.signUp)
    this.emailText = getLocalTranslate('email',this.emailText)
    this.passwordText = getLocalTranslate('password',this.passwordText)
    this.login = getLocalTranslate('login',this.login)
    this.forgotPassword = getLocalTranslate('forgot-password',this.forgotPassword)
    this.connectFacebook = getLocalTranslate('connect-with-facebook',this.connectFacebook)
    this.titleService.setTitle(`${getLocalTranslate('login',this.login)} | CamEdu`);
  }

  show() {
    this.isShow = !this.isShow;
  }

  get email() { return this.loginForm.get('email'); }

  get password() { return this.loginForm.get('password'); }

  // On Submit
  async onSubmit() {
    if (this.loginForm.valid) {
      this.showSpinner = true;

      this.authService.login(this.email.value, this.password.value)
        .then(async (user) => {
          const isOtpVerified = await this.authService.isUserVerified(user.uid);

          if (!isOtpVerified) {
            this.toastr.error('Please verify your email using the OTP code first.');
            this.showSpinner = false;
            return;
          }

          if (this.courseId) {
            this.zone.run(() => {
              this.router.navigate(['course/' + this.courseId]);
            });
            return;
          }

          this.userService.checkUser(user.uid).then(userData => {
            const type = userData?.type;
            localStorage.setItem('user-type', type);

            if (type == 1) {
              this.zone.run(() => {
                this.router.navigate(['my-account/courses']);
              });
            } else {
              this.zone.run(() => {
                this.router.navigate(['my-account/teacher-comments']);
              });
            }
          }).catch(() => {
            this.toastr.error('Oops, Something went wrong!');
            this.showSpinner = false;
          });
        })
        .catch((error) => {
          this.loginForm.reset();
          this.toastr.error(error?.message || 'Invalid email or password!');
          this.showSpinner = false;
        });
    }
  }

  async onLoginWithFacebook() {
    const userCredential = await this.authService.FacebookAuth()
    if(userCredential){
      localStorage.setItem('user-type', '1');
      this.router.navigate(['my-account/courses']);
    }
  }

  onResetPassword(): void {
    const email = this.email?.value?.toString().trim() ?? '';

    if (!this.email || !this.email.valid || !email) {
      this.toastr.error('Please enter a valid email!');
      return;
    }

    this.showSpinner = true;

    this.authService.sendPasswordResetOtp(email)
      .then(() => {
        this.showSpinner = false;
        this.toastr.success('OTP code was sent to your email.');
      })
      .catch((error: any) => {
        this.showSpinner = false;
        this.toastr.error(error?.message || 'Transaction failed!');
      });
  }

}
